export default __webpack_public_path__ + "92702e6eec0e71c4c2ccbae35c755034.woff2";